var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadonPicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "radon",
    d: "M4.88232 6.75781H8.24023C8.94271 6.75781 9.54574 6.86361 10.0493 7.0752C10.5529 7.28678 10.9401 7.59993 11.2109 8.01465C11.4818 8.42936 11.6172 8.93929 11.6172 9.54443C11.6172 10.0226 11.5326 10.4373 11.3633 10.7886C11.194 11.1398 10.9549 11.4339 10.646 11.6709C10.3413 11.9079 9.98161 12.0941 9.56689 12.2295L9.021 12.5088H6.05664L6.04395 11.1313H8.25928C8.61898 11.1313 8.91732 11.0679 9.1543 10.9409C9.39128 10.814 9.56901 10.6383 9.6875 10.4141C9.81022 10.1898 9.87158 9.93376 9.87158 9.646C9.87158 9.33708 9.81234 9.07048 9.69385 8.84619C9.57536 8.61768 9.39551 8.44206 9.1543 8.31934C8.91309 8.19661 8.6084 8.13525 8.24023 8.13525H6.62793V16H4.88232V6.75781ZM10.1001 16L7.96094 11.8613L9.80811 11.855L11.9727 15.9111V16H10.1001ZM14.6641 10.5981V16H12.9883V9.13184H14.5625L14.6641 10.5981ZM14.3975 12.3184H13.9023C13.9066 11.819 13.9743 11.3662 14.1055 10.96C14.2367 10.5537 14.4207 10.2046 14.6577 9.9126C14.8989 9.62061 15.1846 9.39632 15.5146 9.23975C15.8447 9.08317 16.2129 9.00488 16.6191 9.00488C16.9492 9.00488 17.2476 9.05143 17.5142 9.14453C17.7808 9.23763 18.0093 9.38574 18.1997 9.58887C18.3944 9.79199 18.5425 10.0586 18.644 10.3887C18.7498 10.7145 18.8027 11.1165 18.8027 11.5947V16H17.1143V11.582C17.1143 11.2689 17.0677 11.0213 16.9746 10.8394C16.8857 10.6574 16.7546 10.5283 16.5811 10.4521C16.4118 10.376 16.2023 10.3379 15.9526 10.3379C15.6945 10.3379 15.4681 10.3908 15.2734 10.4966C15.083 10.5981 14.9222 10.7399 14.791 10.9219C14.6641 11.1038 14.5667 11.3133 14.499 11.5503C14.4313 11.7873 14.3975 12.0433 14.3975 12.3184Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 1.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadonPicIcon);
export default __webpack_public_path__ + "static/media/RadonPicIcon.d4c13389777d32eb95a5b17306a66594.svg";
export { ForwardRef as ReactComponent };